import {
    rangeInputElement,
    promocodeButtons,
    monthsElement,
    perMonthElement,
    rangeTotal,
    resultByPartsTotal,
    resultFullPriceTotal,
    resultPromocodeText,
    promocodeInputs,
    resultByPartsTotalOld,
    resultFullPriceTotalOld,
    goodIdInput,
} from "./elements";
import store from "./store";
import { updateRangeTrack } from "./range-input";
import { turnIntoLoader, turnIntoButton } from "../../functions";
import * as errors from "../errors";
import axios from "axios";

promocodeButtons.forEach((button) => {
    button.addEventListener("click", usePromocode);
});

export function usePromocode(e) {
    turnIntoLoader(e.currentTarget);
    const button = e.currentTarget;

    const promocode =
        e.currentTarget.parentElement.querySelector("input")?.value;

    if (!promocode) {
        if (store.validPromocode) {
            whiteValues(store.initialPrices);
        }
        store.validPromocode = '';
        resultPromocodeText.classList.remove("show");
        turnIntoButton(e.currentTarget);
        return;
    }

    const data = {
        promo: promocode,
        good_id: goodIdInput.value,
    };

    axios
        .post(`${window.location.origin}/payment/verify`, data)
        .then((res) => {
            store.validPromocode = promocode;

            const response = res.data;

            whiteValues(response);
            resultPromocodeText.classList.add("show");
        })
        .catch(() => {
            if (store.validPromocode) {
                whiteValues(store.initialPrices);
            }
            store.validPromocode = '';
            resultPromocodeText.classList.remove("show");
            errors.createError("Неверный промокод");
        })
        .finally(() => {
            turnIntoButton(button);
        });

    function whiteValues(values) {
        perMonthElement.innerHTML = "";

        values.options.forEach((option, index) => {
            monthsElement.value = rangeInputElement?.value;
            perMonthElement.insertAdjacentHTML(
                "beforeend",
                `
                    <option value="${index}" ${
                    index === rangeInputElement?.value ? "selected" : ""
                } data-old="${option.old || ""}">
                        ${option.current}
                    </option>
                `
            );
        });

        store.currentPrices = {
            full: parseInt(values.full_price.current.replace(/\s+/g, '')),
            installment: parseInt(values.by_parts_total.current.replace(/\s+/g, ''))
        }
        
        rangeTotal.value = values.by_parts_total.current;
        resultByPartsTotal.textContent = values.by_parts_total.current;
        resultFullPriceTotal.textContent = values.full_price.current;
        resultByPartsTotalOld.textContent = values.by_parts_total.old || "";
        resultFullPriceTotalOld.textContent = values.full_price.old || "";
        rangeInputElement.value = rangeInputElement?.value;

        updateRangeTrack(rangeInputElement?.value);
    }
}
